export enum InvoiceStatus {
    Draft = 'Draft',
    Open = 'Open',
    Paid = 'Paid',
    PastDue = 'Past Due',
    Uncollectible = 'Uncollectible',
    Void = 'Void',
}
